import Vue from 'vue';
import Vuex from 'vuex';
import pathify from 'vuex-pathify';
import localeModule from './localeModule';
import authModule from './authModule';
import authorsModule from './authorsModule';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [pathify.plugin],
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    localeModule,
    authorsModule,
    authModule,
  },
});
